import { PayloadAction } from '@reduxjs/toolkit';
import { call, fork, select, takeLatest } from 'redux-saga/effects';
import { IPlayerState, IVideoState, PortraitState, updatePlayerState, updateVideoState } from 'core/slices/player';
import { IUpdateState, updateState } from 'core/actions/product/state';
import { EntityTypes } from 'constants/entities';
import { selectAction, selectActionDAO } from 'core/selectors/product/action/action';
import { IActionBasic, IActionDAO } from 'types/domain/action';
import { Mode, updateMode } from 'core/slices/session';
import { selectSessionMode } from 'core/selectors/admin/sessionMode';

function* updateModeSaga(action) {
  //const prodEnts = yield select((state: RootState) => state.entity.present);
  // console.log(action);
  yield call(toggle, true);
}

function* updatePlayerStateSaga(action: PayloadAction<IPlayerState>) {
  if (action.payload.portrait === PortraitState.SIMULATED_PORTRAIT) yield call(togglePortrait, true);
  else yield call(togglePortrait, false);
}

function* updateStateSaga(action: PayloadAction<IUpdateState>) {
  const mode: Mode = yield select(selectSessionMode);

  if (mode === Mode.LEARNING)
    switch (action.payload.type) {
      case EntityTypes.ACTION:
        //@ts-ignore
        const actionDAO = yield select(s => selectActionDAO(s, action.payload.id));
        yield call(toggle, !!actionDAO?.sceneId);
        break;
      case EntityTypes.SCENE:
        yield call(toggle, true);
    }
  else toggle(true);
}

function* updateVideoStateSaga(action: PayloadAction<IVideoState>) {
  const actionDAO: IActionBasic = yield select(state => selectAction(state, undefined));
  if (actionDAO && actionDAO.sceneId && action.payload.interacted) yield call(toggle, true);
}

function* watchUpdateViewerState() {
  yield takeLatest(updateMode, updateModeSaga);
}

function* watchUpdateState() {
  yield takeLatest(updateState.type, updateStateSaga);
}

function* watchUpdateVideoState() {
  yield takeLatest(updateVideoState.type, updateVideoStateSaga);
}

function* watchUpdatePlayerState() {
  yield takeLatest(updatePlayerState.type, updatePlayerStateSaga);
}

export function* containerSaga() {
  //Not sure this is required. It's causing more problems then it's solving.
  //yield all([fork(watchUpdateViewerState), fork(watchUpdateState), fork(watchUpdateVideoState)]);
  //yield fork(watchUpdatePlayerState);
}

function toggle(show) {
  const player: HTMLDivElement = document.getElementById('player') as HTMLDivElement;

  if (!player) return;
  player.style.display = show ? 'block' : 'none';
  player.style.width = show ? '100%' : '0';
  player.style.height = show ? '100%' : '0';
}

function togglePortrait(show) {
  const player: HTMLDivElement = document.getElementById('player') as HTMLDivElement;

  if (!player) return;
  player.style.width = show ? '375px' : '100%';
  player.style.height = show ? '667px' : '100%';
  player.style.left = show ? 'calc(50%-375px)' : '0px';
  player.style.top = show ? 'calc(50%-667px)' : '0px';
}
